import React from 'react'

import * as styles from 'modules/resultsV2/ResultFailureAlert.styles'
import type { ImportRequestVerificationDetail } from 'services/import-requests/types'

import { useImportRequestFailureAlert } from './hooks/useImportRequestFailureAlert'

interface ImportRequestFailureAlertProps {
  importRequest: ImportRequestVerificationDetail
}

export const ImportRequestFailureAlert: React.FC<ImportRequestFailureAlertProps> = ({ importRequest }) => {
  const { alertType, message } = useImportRequestFailureAlert({ importRequest })

  if (alertType === null || message === null) {
    return null
  }

  if (alertType === 'rejected') {
    return (
      <styles.StyledAlert type="danger" showIcon data-testid="rejected-alert">
        {message}
      </styles.StyledAlert>
    )
  }

  return (
    <styles.StyledAlert type="danger" showIcon data-testid="failed-alert">
      {message}
    </styles.StyledAlert>
  )
}
